import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppMainService } from "src/app/app-main.service";
import { Subject, debounceTime, takeUntil } from "rxjs";
import * as _ from "lodash";
import { OpportunitiesService } from "src/app/opportunities-v2/services/opportunity.service";
import { SharedColumnSettingsService } from "../../services/column-settings.service";
import { MessageService } from "primeng/api";
import { OpportunityModuleId } from "../../constants/modules.constant";
import { ColumnSettingsN, Fields } from "../../models/column-settings.model";
import { SharedChannelService } from "../../services/channel.service";
import { GelAllOpportunityRequestModel } from "src/app/opportunities-v2/models/opportunity-list.model";
import { AccountHelper } from "src/app/accounts-v2/services/accounts.helper";
import { ImportserialService } from "../../services/importserial.service";

@Component({
    selector: "app-account-associated-opportunity",
    templateUrl: "./account-associated-opportunity-modal.component.html",
    styleUrls: ["./account-associated-opportunity-modal.component.scss"],
})
export class AccountAssociatedOpportunityModalComponent implements OnInit, OnChanges, OnDestroy {
    @Input({ required: true }) displayOpportunitySelectionDialog: boolean;
    @Input({ required: true }) account: any;
    @Input() selectedOpportunity: any;
    @Input() accountChannelId: number;

    @Output() onCancel = new EventEmitter();
    @Output() onSelect = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    opportunities: any[] = [];
    opportunityCols: any[] = [];
    pageSize: number = 15;
    totalRecords: number = 0;
    fractionDigits: number = 0;
    tableShowMore: number[] = [15 , 30 , 50 ,100];
    firstPage: number = 0;
    headerTitle: string = "Select Opportunity";
    columnSettingsN: Partial<ColumnSettingsN> = {};
    private ngUnsubscribe = new Subject<void>();
    selectedPipeline: any = {};
    // listing
    sortByColumnName: string = '';
    searchText: string = "";
    selectedView: string = "list";
    isSortByDescending: boolean = true;
    fromUpdateSettings: boolean = false;
    displayColumnSettings: boolean  = false;
    isActive: boolean = true;
    pageNumber: number = 1;
    first: number = 0;
    selectedStageId: number;
    selectedGroupByValue: any = null;
    savedListColsVM: Fields[] = [];
    selectedColumn: string[] = [];
    rowGroupMetadata: Array<any> = [];
    menuItems : Array<any>  = [];
    disabledLabelNames: string[] = [];
    private searchSubject: Subject<string> = new Subject<string>();

    constructor(
        private appMainService: AppMainService,
        private accountHelper: AccountHelper,
        private sharedColumnSettingsService: SharedColumnSettingsService,
        private messageService: MessageService,
        private sharedChannelService: SharedChannelService,
        private opportunityService: OpportunitiesService,private importService: ImportserialService,
    ) {}

    ngOnInit(): void {
        this.searchSubject.pipe(debounceTime(300)).subscribe((searchText) => {
            this.searchText = searchText;
            this.getOpportunityList(this.pageNumber, this.pageSize);
        });
        this.menuItems = [
            {
                label: "Settings",
                icon: "pi pi-cog ",
                command: (event) => this.openContactSettings(),
            },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
    if (changes.account && this.account) {
        this.getOpportunityChannels();
     }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    getFractionDigits() {
        this.importService.getDecimalValue().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
            });
    }

    getOpportunityChannels(selectedPipelineId: number = 0): void {
        this.appMainService.isShowSpinner("getChannel");
        this.sharedChannelService
            .getAllChannels(OpportunityModuleId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    const channels = response || [];
                    if (selectedPipelineId > 0) {
                        this.selectedPipeline = channels?.find((el) => el.id == selectedPipelineId);
                    } else {
                        this.selectedPipeline = channels?.find((el) => el.isDefault);
                    }
                    if (!this.selectedPipeline) {
                        this.selectedPipeline = channels?.find((el) => el.isDefault);
                    }
                    if (this.selectedPipeline?.id) {
                        this.getColumnSettings(false);
                    }
                    this.appMainService.isHideSpinner("getChannel");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getChannel");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.message ? error?.error?.message : "Channels are not loaded, please try again...",
                    });
                },
                complete: () => {},
            });
    }

    getColumnSettings(fromUpdateSettings = false): void {
        this.appMainService.isShowSpinner("getColumnSettings");
        this.sharedColumnSettingsService
            .getColumnSettings(OpportunityModuleId, this.selectedPipeline?.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.columnSettingsN = response || [];
                    if (this.columnSettingsN?.listViewSections) {
                        this.savedListColsVM = this.accountHelper.getSectionWiseFlatCols(this.columnSettingsN?.listViewSections);
                    }
                    this.appMainService.isHideSpinner("getColumnSettings");
                    if (!fromUpdateSettings) {
                        this.getOpportunityList(this.pageNumber, this.pageSize);
                    }
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getColumnSettings");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.message ? error?.error?.Message : "Column Settings are not loaded, please try again...",
                    });
                },
                complete: () => {},
            });
    }

    getOpportunityList(currentPageNumber: number = 1, currentPageSize: number = 15, fromUpdateSettings?: boolean, lastUpdatedId?: number) {
        this.appMainService.isShowSpinner("getOpportunityList");
        const pageNumber = currentPageNumber;
        this.pageNumber = pageNumber;
        this.pageSize = currentPageSize;
        const selectableColumns: any[] = [];
        this.selectedColumn = [];
        if (this.savedListColsVM.length > 0) {
            this.savedListColsVM?.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push({
                        columnName: obj.columnName,
                        isCustom: obj.isCustom,
                    });
                }
            });
            this.selectedColumn = selectableColumns;
        }
        const sortByColumn = this.savedListColsVM?.find((fld) => fld.columnName == this.sortByColumnName);
        const requestModel = this.requestPayload(selectableColumns,currentPageSize,currentPageNumber,sortByColumn)
        const apiCall = this.opportunityService.getOpportunityListWithFilters(requestModel);
        apiCall.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner("getOpportunityList");
                if (response) {
                    this.rowGroupMetadata = this.selectedGroupByValue ? response.groupedList || [] : response?.list || [];
                    this.totalRecords = response?.totalNumberOfRows;
                }
            },
            error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error!",
                    detail: "Error occurring when loading opportunities. Please try after sometime.",
                });
                this.appMainService.isHideSpinner("getOpportunityList");
            },
            complete: () => {},
        });
    }

    requestPayload(selectableColumns,currentPageSize,currentPageNumber,sortByColumn){
        const requestModel: GelAllOpportunityRequestModel = {
            channelId: this.accountChannelId ,
            accountChannelId: this.accountChannelId ,
            stageId: null,
            isActive: this.isActive,
            globalSearchValue: this.searchText.trim() || "",
            selectableColumns: selectableColumns,
            filter: "",
            pageSize: currentPageSize,
            pageNumber: currentPageNumber,
            sortByColumn: this.sortByColumnName || null,
            sortByColumnDataType: sortByColumn?.fieldDataType || null,
            isSortByDescending: this.isSortByDescending,
            filterInColumns: [
                {
                    name: "accountId",
                    operator: "IsEqualTo",
                    operationType: "AND",
                    values: [
                        this.account?.id
                    ]
                }
            ],
        };
        return requestModel
    }

    cancel(): void {
        this.onCancel.emit();
    }

    save(): void {
        this.onSelect.emit({ selectedOpportunity: this.selectedOpportunity });
    }

    getData(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        this.first = event.first;
        this.getOpportunityList(this.pageNumber, this.pageSize);
    }

    openContactSettings(): void {
        this.getColumnSettings(true);
        this.displayColumnSettings = true;
    }

    //sort on column
    onSortColumn(event) {
        this.sortByColumnName = event.field;
        this.isSortByDescending = event.order !== 1;
        this.getOpportunityList(this.pageNumber, this.pageSize);
    }

    onSearchInput(event: Event): void {
        const input = event?.target as HTMLInputElement;
        this.searchSubject.next(input.value);
    }

    savedColumnSettings(): void {
        this.displayColumnSettings = false;
        this.getColumnSettings(false);
    }

    cancelColumnSettings(): void {
        this.displayColumnSettings = false;
    }


}
